export const WalletNavigationEnum = Object.freeze({
    MANAGE: "MANAGE",
    PURCHASE: "PURCHASE",
});

export const WalletListTabIds = Object.freeze({
    MY_GIFT_CARDS: 0,
    SENT_GIFT_CARDS: 1,
});
